import * as React from "react";
import { InvestmentAllocation } from "../../../../../../../Wrap/Models/Domains/Investment/InvestmentAllocation";
import { Table } from "../../../../../../Shared/Table/Table";
import { Money } from "../../../../../../../Wrap/Core/DataTypes/Money";
import { MoneyDisplayHelper } from "../../../../../../../react-core/Helpers/MoneyDisplayHelper";

interface IInvestmentReviewTableProps {
    data: InvestmentAllocation[];
    allocationType: InvestmentReviewType;
    amount: Money
}
export const enum InvestmentReviewType {
    Sell = 1,
    Buy = 2
}

export const InvestmentReviewTable = (props: IInvestmentReviewTableProps) => {

    const { data, allocationType, amount } = props;
    let total = data?.reduce((sum, curr) => {
        return (sum = sum + curr.Percentage);
    }, 0);

    return (
        <>
            <Table
                data={data.filter(allocation => allocation.Percentage !== null)}
                col={[
                    {
                        title: "Investment",
                        key: "Name",
                    },
                    {
                        title: allocationType == InvestmentReviewType.Sell ? "Estimated amount to sell" : "% amount to purchase",
                        key: "Percentage",
                        render: (data, row, index) => {
                            return <span className="symbol">
                            {data.toFixed(2)}% (
                            {amount && MoneyDisplayHelper.FromatMoneyDisplay(parseFloat((amount.Amount * data * 0.01).toFixed(2)), amount.Currency)}
                            )
                        </span>;                        
                        },
                    }
                ]}
                TotalBody={[
                    { data: allocationType == InvestmentReviewType.Sell ? "Estimated total to sell" : "% amount to purchase", colSpan: 1 },
                    {
                        data: <span>{total}% ({MoneyDisplayHelper.FromatMoneyDisplay(amount.Amount * total * 0.01, amount.Currency)})</span>,
                        colSpan: 1,
                    },
                ]}
            />
        </>
    );
}

